/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Fade, Slide } from "react-awesome-reveal";
import "./About.scss";
import Testimonials from "../../components/Testimonials/Testimonials";

function AboutPage() {
  return (
    <div className="about-wrap">
      <div className="container">
        <div className="heading ">
          <Slide direction="up">
            <h3>ABOUT US</h3>
          </Slide>
        </div>
        <div className="content  ">
          <Fade>
            <div className="about-info">
              <div className="ai-1">
                {/* Welcome to WowWishMoments, a main occasion coordinator and decorator situated in Meerut with 2 years of involvement with making remarkable minutes for our clients.

At WowWishMoments, we accept that each occasion is novel and should be customized by the inclinations and style of the host. Our group of capable experts is focused on conveying uncommon administrations and making vital encounters for all events, from weddings and birthday events ato corporate occasions and get-togethers.

We have some expertise in occasion arranging, plan, and execution, guaranteeing that everything about dealt with and the occasion chugs along as expected beginning to end. Our administrations incorporate setting determination, catering, style, lighting, diversion, and that's just the beginning, all custom-made to meet the particular requirements and assumptions for our clients.

With WowWishMoments, you can believe that your occasion will be good to go, and that each angle will be painstakingly thought out and executed flawlessly. We are enthusiastic about what we do and invest wholeheartedly in conveying outstanding administrations that surpass our clients' assumptions.

Much thanks to you for thinking about WowWishMoments for your next occasion. We anticipate assisting you with making remarkable minutes that will endure forever. */}

                <p>
                  Welcome to WowWishMoments, a main occasion coordinator and
                  decorator situated in Meerut with 2 years of involvement with
                  making remarkable minutes for our clients.
                </p>
                <p>
                  At WowWishMoments, we accept that each occasion is novel and
                  should be customized by the inclinations and style of the
                  host.{" "}
                  <b>
                    Our group of capable experts is focused on conveying
                    uncommon administrations and making vital encounters for all
                    events, from weddings and birthday events ato corporate
                    occasions and get-togethers.
                  </b>
                </p>
                <p>
                  We have some expertise in occasion arranging, plan, and
                  execution, guaranteeing that everything about dealt with and
                  the occasion chugs along as expected beginning to end. Our
                  administrations incorporate setting determination, catering,
                  style, lighting, diversion, and that's just the beginning, all
                  custom-made to meet the particular requirements and
                  assumptions for our clients.
                </p>
              </div>
              <div className="ai-2">
                <p>
                  With WowWishMoments, you can believe that your occasion will
                  be good to go, and that each angle will be painstakingly
                  thought out and executed flawlessly. We are enthusiastic about
                  what we do and invest wholeheartedly in conveying outstanding
                  administrations that surpass our clients' assumptions.
                </p>
                <h6>
                  <b>
                    <em>
                      Much thanks to you for thinking about WowWishMoments for
                      your next occasion. We anticipate assisting you with
                      making remarkable minutes that will endure forever.{" "}
                    </em>
                    {/* <em>
                      We are WowWish<small>Momemts</small>
                    </em> */}
                  </b>
                </h6>
                <h6>
                  <b>
                    <em>
                      We are WowWish<small>Momemts</small>
                    </em>
                  </b>
                </h6>
              </div>
            </div>
          </Fade>

          <div className="approach-our spacing">
            <Fade>
              <div className="oa-inner">
                <h4>Our Approach & Process</h4>
                <div className="or-content">
                  <Fade>
                    <div className="or-item-wrap">
                      <div className="title">
                        <b>STRATEGY</b>
                      </div>
                      <div className="desc">
                        Understanding Vision + Key Objectives Brainstorming +
                        Plan Implementation
                      </div>
                    </div>
                    <div className="or-item-wrap">
                      <div className="title">
                        <b>IDEATION</b>
                      </div>
                      <div className="desc">
                        Conceptualization of Event Venue Selection
                      </div>
                    </div>
                    <div className="or-item-wrap">
                      <div className="title">
                        <b>DESIGN</b>
                      </div>
                      <div className="desc">
                        Design Concept + Creative Elements
                      </div>
                    </div>
                    <div className="or-item-wrap">
                      <div className="title">
                        <b>DEVELOPMENT</b>
                      </div>
                      <div className="desc">
                        Planning + Preparation, Budget Allocation, Program
                        Implementation
                      </div>
                    </div>

                    <div className="or-item-wrap">
                      <div className="title">
                        <b>ACTIVATION</b>
                      </div>
                      <div className="desc">
                        Activation of Event + Synopsis of Event
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </Fade>
          </div>

          <div className="ab-testimonials spacing">
            <div className="container">
              <div className="row">
                <div className="r-col">
                  <Fade>
                    <h3>Testimonials</h3>
                  </Fade>
                </div>
                <Testimonials />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
